import { defineComponent as _defineComponent } from 'vue'
import { computed } from "@nuxtjs/composition-api";


export default /*#__PURE__*/_defineComponent({
  __name: 'CartsModal',
  props: {
  value: {
    type: Boolean,
    default: false,
  },
},
  emits: ["input"],
  setup(__props, { emit }: { emit: ({
  (event: "input", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const model = computed({
  get() {
    return props.value;
  },
  set(newValue) {
    emit("input", newValue);
  },
});

return { __sfc: true,props, emit, model }
}

})